import {ReactComponent as LogoBrandmark} from "../assets/images/logo-new-brandmark.svg";
import React from 'react';

import LayoutPublicPage from "../components/common/LayoutPublicPage";
import ButtonLink from "../components/common/ButtonLink";

function NotFound() {
  return (
    <LayoutPublicPage pageTitle="Not found" pageBodyClassName="c-error">

      <i className="c-public-page-section-content-logo">
        <LogoBrandmark/>
      </i>

      <div className="c-public-page-section-content-header">
        <h1>404</h1>
        <h2 className="h6">Oops, looks like this page doesn't exist.</h2>
        <p>Let's get you back on track!</p>
      </div>

      <ButtonLink
        url="/"
        text="Go back"
        btnSize="lg"
      />

    </LayoutPublicPage>
  );
}

export default NotFound;